import {
  mq,
  Heading as _Heading,
  FONT_SIZE,
  COLOR,
  EllipsisAccordion as _EllipsisAccordion,
  ItemThumbnail as _ItemThumbnail,
  FONT_WEIGHT,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { LINE_STYLE } from "~/styles/line-style";

export const SecHeadingWrapper = styled.section`
  display: flex;
  align-items: center;
`;

// TODO（kimura） : ItemThumbnail の ProgressBar の色がBLUEのためYELLOWに変更する必要ある。時間ないので以下のコードで対応
export const ItemThumbnail = styled(_ItemThumbnail)`
  span[role="progressbar"] {
    background-color: ${COLOR.YELLOW900.code};
  }
`;

export const HeadingEpisodeTitle = styled(_Heading)`
  ${LINE_STYLE(1)}
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: ${FONT_SIZE.M}px;

  ${mq.sp} {
    ${LINE_STYLE(2)}
    font-size: ${FONT_SIZE.S}px;
  }
`;

export const DivDownloadIconFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
`;

export const BtnDownloadIcon = styled.button`
  padding: 8px;
  cursor: pointer;

  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
`;

export const DivRootPadding = styled.div`
  padding-bottom: 32px;

  &:last-of-type {
    padding-bottom: 0px;
  }

  ${mq.sp} {
    padding-bottom: 16px;
  }
`;

export const DivItemFlexContainer = styled.div`
  display: flex;
`;

export const DivEpisodeGrid = styled.div`
  display: grid;
  grid-gap: 8px;
  flex-grow: 1;
  align-content: flex-start;
  margin-left: 16px;

  ${mq.sp} {
    grid-gap: 4px;
    margin-left: 8px;
  }
`;

export const TitleGrid = styled.div<{ height?: number }>`
  display: grid;
  grid-gap: 8px;
  flex-grow: 1;
  align-content: flex-start;
  ${mq.sp} {
    grid-gap: 4px;
    height: ${({ height }) => height}px;
    align-content: center;
  }
`;

export const EllipsisAccordion = styled(_EllipsisAccordion)`
  color: ${COLOR.GRAY500.code};
  margin-top: 8px;
`;

export const BtnPurchase = styled.button`
  width: fit-content;
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.BLUE900.code};

  @media (any-hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const BtnThumbnail = styled.button`
  display: flex;
  align-items: flex-start;
  border-radius: 8px;

  &:disabled {
    pointer-events: none;
  }

  &:focus-visible {
    outline: 4px solid ${COLOR.YELLOW900.code};
  }
`;

export const ParSupplementText = styled.p`
  ${LINE_STYLE(1)}
  color: ${COLOR.GRAY500.code};
  font-size: ${FONT_SIZE.S}px;

  ${mq.sp} {
    margin-top: 8px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;
